import { Controller } from "@hotwired/stimulus"

// Submits the parent form when a field value changes.
// Usage: <form data-controller="auto-submit">
//          <select data-action="change->auto-submit#submit">
//          <input  data-action="change->auto-submit#submit blur->auto-submit#submit">
//
// Optional: reload the page after a successful submission — same behaviour
// as the settings "Clear cache" button (full reload), without wiping any
// storage. Used when the change affects server-rendered content on other
// screens (e.g. currency), so stale cached pages get re-fetched.
// Usage: <form data-controller="auto-submit" data-auto-submit-reload-value="true">
export default class extends Controller {
  static values = { reload: { type: Boolean, default: false } }

  connect() {
    if (!this.reloadValue) return
    this._onSubmitEnd = (event) => {
      if (event.detail.success) window.location.reload()
    }
    this.element.addEventListener("turbo:submit-end", this._onSubmitEnd)
  }

  disconnect() {
    if (this._onSubmitEnd) {
      this.element.removeEventListener("turbo:submit-end", this._onSubmitEnd)
      this._onSubmitEnd = null
    }
  }

  submit() {
    this.element.requestSubmit()
  }
}
